import React, { Fragment, Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { change as changeFieldValue, Field, formValueSelector, reduxForm } from 'redux-form';
import {
    renderField,
    renderFieldNumber,
    renderFieldDataNascimento,
    renderFieldSelect,
    ano,
    renderFieldPlacaVeiculo,
    placa,
    required,
    renderFieldRenavam,
} from '../../util/inputs';
import Titulo from '../comum/Titulo';
import { getAdminEmpresa, getFiscalEmbarque, getOperadorEmpresa, getGestorOperacoes, PERFIL_ADMIN } from '../../security/securityContext';
import Autorizacao from '../../security/Autorizacao';
import { isAmbienteDev, tamanhoArquivoUpload } from '../../util/applicationContext';
import cadastrarVeiculo from '../../actions/veiculo/cadastrarVeiculo'
import buscarVeiculos from '../../actions/veiculo/buscarVeiculos';
import alterarVeiculo from '../../actions/veiculo/alterarVeiculo'
import { showSuccessMsg } from '../../util/messagesUtil';
import ModalSelecionarMapaVeiculo from './ModalSelecionarMapaVeiculo';
import MapaVeiculo from '../mapa-veiculo/MapaVeiculo';
import alterarMapaSelecionadoVeiculo from '../../actions/veiculo/alterarMapaSelecionadoVeiculo';
import { campoTipoVeiculo, empresaSeguro } from '../../util/constantsUtil';
import moment from 'moment'
import CheckboxGroupTipoServico from './CheckboxGroupTipoServico';
import { gerarHashForString } from '../../util/stringUtil';
import ImageGridUpload from './ImageGridUpload';
import Modal from './Modal';

const SectionCard = ({ icon, title, subtitle, children }) => (
    <div className="vx-config-card">
        <div className="vx-config-card-header">
            <i className="material-icons">{icon}</i>
            <div className="vx-config-card-header-text">
                <h6>{title}</h6>
                {subtitle && <small>{subtitle}</small>}
            </div>
        </div>
        <div className="vx-config-card-body">
            {children}
        </div>
    </div>
);

export const validate = (values) => {
    const errors = {};
    if (!values.nome) errors.nome = 'Campo obrigatório';
    if (!values.tipo) errors.tipo = 'Campo obrigatório';
    if (!values.qtdPoltronas) errors.qtdPoltronas = 'Campo obrigatório';
    if (!values.posicaoPorta) errors.posicaoPorta = 'Posição da porta obrigatória.';
    return errors;
};

export function ehDataValida(value) {
    if (value && value !== '__/__/____' && !moment(value, 'DD/MM/YYYY', true).isValid()) {
        return 'Data inválida';
    }
    return undefined;
}

const LIMITE_UPLOAD_ARQUIVO = 7;

export class PainelCadastrarVeiculo extends Component {
    constructor(props) {
        super(props);
        this.limparFormulario = this.limparFormulario.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.state = {
            mensagens: [],
            veiculoSelecionado: null,
            tipoVeiculo: null,
            tipoServico: [],
            arquivos: [],
            selectedImg: null,
        };
    }

    handleTipoVeiculo(e) {
        this.setState({ tipoVeiculo: e.value });
    }

    handleCheckboxGroup(valores) {
        if (valores) {
            const array = valores.map(it => it ? it.chave : null);
            this.setState({ tipoServico: array });
        }
    }

    componentDidMount() {
        this.props.alterarMapaSelecionadoVeiculo(null);
        this.carregarFormulario();
    }

    carregarFormulario() {
        const set = (f, v) => this.props.changeFieldValue('formularioPainelCadastroVeiculo', f, v);
        const v = this.props.veiculoSelecionado;

        set('mapaVeiculo', v.mapaVeiculoDto);
        set('descricao', v.descricao);
        set('idVeiculo', v.id);
        set('idRastreamento', v.idRastreamento);
        set('base64Veiculo', v.base64Veiculo);
        set('urlImagem', v.urlImagem);
        set('placa', v.placa);
        set('modelo', v.modelo);
        set('tipoVeiculo', v.tipoVeiculo ? { label: v.tipoVeiculo.valor, value: v.tipoVeiculo.chave } : null);
        set('quilometragem', v.quilometragem);
        set('renavam', v.renavam);
        set('anoFabricacao', v.anoFabricacao);
        set('numeroEixo', v.numeroEixo);
        set('dataVencimentoCsv', v.dataVencimentoCsv);
        set('tara', v.tara);
        set('chassi', v.chassi);

        const chaveEmpresaSeguro = v.empresaSeguro;
        const dadosEmpresaSeguro = chaveEmpresaSeguro ? empresaSeguro[chaveEmpresaSeguro] : null;
        set('empresaSeguro', dadosEmpresaSeguro ? {
            label: `${dadosEmpresaSeguro.cnpj} ${dadosEmpresaSeguro.empresa}`,
            value: chaveEmpresaSeguro,
        } : null);
        set('apolice', v.apolice);

        this.props.alterarMapaSelecionadoVeiculo(v.mapaVeiculoDto);

        if (v.imagens) {
            const imagens = v.imagens.map(it => ({
                hash: gerarHashForString(`${it.nome}`),
                ...it,
            }));
            this.setState({ arquivos: imagens });
        }
    }

    exibirBotaoSelecionarModelo() {
        return (
            <Autorizacao perfisPermitidos={[
                PERFIL_ADMIN,
                getAdminEmpresa(this.props.empresaSelecionada.id),
                getGestorOperacoes(this.props.empresaSelecionada.id),
                getOperadorEmpresa(this.props.empresaSelecionada.id),
            ]}>
                <button
                    data-toggle="modal"
                    data-target="#modalSelecionarMapaVeiculo"
                    className="vx-toolbar-btn"
                    onClick={() => this.selecionarTipoVeiculoParaMapaVeiculo()}>
                    <i className="material-icons" style={{ fontSize: 16 }}>event_seat</i>
                    Selecionar modelo de veículo
                </button>
            </Autorizacao>
        );
    }

    selecionarTipoVeiculoParaMapaVeiculo() {
        const first = campoTipoVeiculo.find(it => it.chave == this.state.tipoVeiculo);
        if (first) {
            this.props.changeFieldValue('formularioMapasVeiculos', 'tipo', {
                label: first.valor,
                value: first.chave,
            });
        }
    }

    selecionarMapa() {
        if (this.props.mapaSelecionadoVeiculo) {
            this.props.alterarMapaSelecionadoVeiculo(null);
            this.props.changeFieldValue('formularioPainelCadastroVeiculo', 'mapaVeiculo', null);
        }
    }

    getTotalAssentosPorAndar(andar) {
        const fileiras = andar == 1
            ? this.props.mapaSelecionadoVeiculo.fileirasPrimeiroAndar
            : this.props.mapaSelecionadoVeiculo.fileirasSegundoAndar;
        let total = 0;
        for (let chave in fileiras) {
            fileiras[chave].assentos.forEach(it => {
                if (it.tipoAssento === 'NORMAL') total++;
            });
        }
        return total;
    }

    exibirMapas() {
        if (!this.props.mapaSelecionadoVeiculo) return null;
        return (
            <div>
                <div style={{ display: 'flex', gap: 20, flexWrap: 'wrap', marginBottom: 12 }}>
                    <span style={{ fontSize: 13, color: '#555' }}>
                        <strong>Total de poltronas:</strong> {this.props.mapaSelecionadoVeiculo.quantidadeAssentos}
                    </span>
                    {this.props.mapaSelecionadoVeiculo.seDoisAndares && (
                        <>
                            <span style={{ fontSize: 13, color: '#555' }}>
                                <strong>1° andar:</strong> {this.getTotalAssentosPorAndar(1)}
                            </span>
                            <span style={{ fontSize: 13, color: '#555' }}>
                                <strong>2° andar:</strong> {this.getTotalAssentosPorAndar(2)}
                            </span>
                        </>
                    )}
                </div>
                <MapaVeiculo
                    mapaVeiculo={this.props.mapaSelecionadoVeiculo}
                    selecionar={this.selecionarMapa.bind(this)}
                    selecionado={this.props.mapaSelecionadoVeiculo}
                />
            </div>
        );
    }

    handleChange(event) {
        const chooseFiles = Array.prototype.slice.call(event.target.files);
        const arquivos = [...this.state.arquivos];
        const mensagens = [];

        if (chooseFiles.length > LIMITE_UPLOAD_ARQUIVO) {
            mensagens.push({ tipo: 'erro', nomeArquivo: chooseFiles[chooseFiles.length - 1].name, texto: 'Limite excedido de arquivos para upload.' });
            this.setState({ mensagens });
            return;
        }

        const limite = arquivos.length + chooseFiles.length;

        chooseFiles.forEach(file => {
            if (arquivos.findIndex(arq => arq.nome === file.name) === -1) {
                if (/\.(jpe?g|png|webp)$/i.test(file.name) === false) {
                    mensagens.push({ tipo: 'erro', nomeArquivo: file.name, texto: 'Formato inválido. Use JPEG, PNG ou WebP.' });
                } else if (limite >= 0 && arquivos.length > LIMITE_UPLOAD_ARQUIVO) {
                    mensagens.push({ tipo: 'erro', nomeArquivo: file.name, texto: 'Limite excedido de arquivos para upload.' });
                } else if (file.size > tamanhoArquivoUpload) {
                    mensagens.push({ tipo: 'erro', nomeArquivo: file.name, texto: 'Tamanho do arquivo excede 20 MB.' });
                } else {
                    this.converterParaBase64(file);
                }
            }
        });

        this.setState({ mensagens });
    }

    converterParaBase64(file) {
        const obj = { hash: gerarHashForString(`${file.name}`), nome: file.name, base64Veiculo: null, urlImagem: null, principal: false };
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            const arquivos = [...this.state.arquivos];
            obj.base64Veiculo = reader.result;
            obj.urlImagem = reader.result;
            obj.principal = arquivos.length <= 0;
            arquivos.push(obj);
            this.setState({ arquivos });
        }.bind(this);
        reader.onerror = function () {
            const mensagens = [...this.state.mensagens];
            mensagens.push({ tipo: 'erro', nomeArquivo: file.name, texto: 'Imagem inválida. Selecione outra imagem.' });
            this.setState({ mensagens });
            this.removerImagem(obj);
        }.bind(this);
    }

    setImagemPrincipal(file) {
        const arquivos = [...this.state.arquivos];
        arquivos.forEach(it => { it.principal = false; });
        arquivos.forEach(it => { if (file.hash === it.hash) it.principal = true; });
        this.setState({ arquivos });
    }

    removerImagem(arquivo) {
        const arquivos = [...this.state.arquivos].filter(it => it.hash != arquivo.hash);
        if (arquivo.principal && arquivos.length > 0) arquivos[0].principal = true;
        this.setState({ arquivos });
    }

    setSelectedImg(selectedImg) {
        this.setState({ selectedImg });
    }

    limparMensagem() {
        this.setState({ mensagens: [] });
    }

    salvar() {
        const parametros = {
            id: this.props.idVeiculo,
            descricao: this.props.descricao,
            empresaId: this.props.empresaSelecionada.id,
            mapaVeiculoId: this.props.mapaSelecionadoVeiculo && this.props.mapaSelecionadoVeiculo.id,
            idRastreamento: this.props.idRastreamento,
            placa: this.props.placa,
            modelo: this.props.modelo,
            tipoVeiculo: this.state.tipoVeiculo ? this.state.tipoVeiculo : this.props.tipoVeiculo && this.props.tipoVeiculo.value,
            quilometragem: this.props.quilometragem,
            renavam: this.props.renavam,
            chassi: this.props.chassi,
            anoFabricacao: this.props.anoFabricacao,
            numeroEixo: this.props.numeroEixo,
            dataVencimentoCsv: this.props.dataVencimentoCsv,
            empresaSeguro: this.props.empresaSeguro && this.props.empresaSeguro.value,
            apolice: this.props.apolice,
            tara: this.props.tara,
            tipoServico: this.state.tipoServico.filter(it => it != null),
            imagens: this.state.arquivos,
        };

        if (this.props.idVeiculo) {
            this.props.alterarVeiculo(parametros).then(() => {
                this.limparFormulario();
                this.props.buscarVeiculos(this.props.empresaSelecionada.id);
                this.props.history.push('/painel-veiculos');
                showSuccessMsg('Veículo alterado com sucesso');
            });
        } else {
            this.props.cadastrarVeiculo(parametros).then(() => {
                this.limparFormulario();
                this.props.history.push('/painel-veiculos');
                showSuccessMsg('Veículo cadastrado com sucesso');
                this.props.buscarVeiculos(this.props.empresaSelecionada.id);
            });
        }
    }

    limparFormulario() {
        this.props.reset('formularioPainelCadastroVeiculo');
        this.props.alterarMapaSelecionadoVeiculo(null);
    }

    naoEhEmbarcacao() {
        return (this.props.tipoVeiculo && this.props.tipoVeiculo.value != 'EMBARCACAO') || this.state.tipoVeiculo != 'EMBARCACAO';
    }

    render() {
        const { invalid } = this.props;
        const ehEdicao = !!this.props.idVeiculo;

        return (
            <Autorizacao perfisPermitidos={[
                PERFIL_ADMIN,
                getAdminEmpresa(this.props.empresaSelecionada.id),
                getGestorOperacoes(this.props.empresaSelecionada.id),
                getOperadorEmpresa(this.props.empresaSelecionada.id),
                getFiscalEmbarque(this.props.empresaSelecionada.id),
            ]}>
                <div className="container-padrao">
                    <Titulo texto={ehEdicao ? 'Editar Veículo' : 'Cadastrar Veículo'} urlRetorno="/painel-veiculos" />

                    {/* Alertas de upload */}
                    {this.state.mensagens.map((mensagem, index) => (
                        <div key={`msg-${index}`} className={`vx-config-alert vx-config-alert--${mensagem.tipo === 'sucesso' ? 'sucesso' : 'erro'}`}>
                            <i className="material-icons">{mensagem.tipo === 'sucesso' ? 'check_circle' : 'error_outline'}</i>
                            <span>
                                {mensagem.texto}
                                {mensagem.nomeArquivo && <strong> ({mensagem.nomeArquivo})</strong>}
                            </span>
                            <button type="button" onClick={() => this.limparMensagem()}>
                                <i className="material-icons" style={{ fontSize: 18 }}>close</i>
                            </button>
                        </div>
                    ))}

                    <div className="vx-config-page">

                        {/* ── Identificação ── */}
                        <SectionCard icon="directions_bus" title="Identificação do Veículo" subtitle="Tipo, descrição e dados básicos">
                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 2fr', gap: 16 }}>
                                <Field name='tipoVeiculo'
                                    options={campoTipoVeiculo.map(elemento => ({
                                        descricao: elemento.valor,
                                        nome: elemento.chave,
                                    }))}
                                    onChange={(e) => this.handleTipoVeiculo(e)}
                                    component={renderFieldSelect}
                                    label='Tipo de Veículo:'
                                    placeholder='Selecione...'
                                    menuPortalTarget={document.body}
                                />
                                <Field name="descricao" type="text" component={renderField}
                                    validate={[required]}
                                    label="Descrição:"
                                    css="form-control" readOnly={false} />
                            </div>
                            {isAmbienteDev() && (
                                <div style={{ maxWidth: 260, marginTop: 14 }}>
                                    <Field name="idRastreamento" type="text" component={renderFieldNumber}
                                        formatacao="#######"
                                        label="Identificador de rastreamento:"
                                        css="form-control" />
                                </div>
                            )}
                        </SectionCard>

                        {/* ── Imagens ── */}
                        <SectionCard icon="photo_library" title="Imagens do Veículo" subtitle={`Selecione até ${LIMITE_UPLOAD_ARQUIVO} imagens (JPEG, PNG, WebP — máx. 20 MB cada)`}>
                            <div className="input-wrapper" style={{ marginBottom: 16 }}>
                                <label htmlFor='input-file'>
                                    {this.state.arquivos.length > 0 ? 'Adicionar mais imagens' : 'Selecionar imagens'}
                                </label>
                                <input id='input-file' type='file' value='' accept="image/*"
                                    onChange={this.handleChange.bind(this)} multiple />
                            </div>
                            {this.state.arquivos.length > 0 && (
                                <p style={{ fontSize: 12, color: '#888', marginBottom: 8 }}>
                                    <i className="material-icons" style={{ fontSize: 13, verticalAlign: 'middle', marginRight: 4 }}>info_outline</i>
                                    Clique em uma imagem para definir como principal.
                                </p>
                            )}
                            <div className='img-grid'>
                                {this.state.arquivos.map((arq, index) => (
                                    <Fragment key={`file-${index}`}>
                                        <ImageGridUpload
                                            setSelectedImg={this.setSelectedImg.bind(this)}
                                            file={arq}
                                            removerImagem={this.removerImagem.bind(this)}
                                            setImagemPrincipal={this.setImagemPrincipal.bind(this)}
                                        />
                                    </Fragment>
                                ))}
                                {this.state.selectedImg && (
                                    <Modal selectedImg={this.state.selectedImg} setSelectedImg={this.setSelectedImg.bind(this)} />
                                )}
                            </div>
                        </SectionCard>

                        {/* ── Modelo de Assentos ── */}
                        <SectionCard icon="event_seat" title="Modelo de Assentos" subtitle="Selecione o mapa de poltronas para este veículo">
                            {this.props.mapaSelecionadoVeiculo ? (
                                this.exibirMapas()
                            ) : (
                                this.exibirBotaoSelecionarModelo()
                            )}
                        </SectionCard>

                        {/* ── Dados Técnicos (apenas não-embarcação) ── */}
                        {this.naoEhEmbarcacao() && (
                            <>
                                <SectionCard icon="assignment" title="Dados Técnicos" subtitle="Placa, renavam, chassi, quilometragem e documentação">
                                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 2fr', gap: 16, marginBottom: 14 }}>
                                        <Field name="placa" type="text" component={renderFieldPlacaVeiculo}
                                            max={8} label="Placa:" css="form-control" readOnly={false}
                                            validate={[placa]} />
                                        <Field name="modelo" type="text" component={renderField}
                                            label="Modelo:" css="form-control" readOnly={false} />
                                    </div>
                                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 2fr 1fr 1fr', gap: 16, marginBottom: 14 }}>
                                        <Field name="renavam" type="text" component={renderFieldRenavam}
                                            max={11} label="Renavam:" css="form-control" readOnly={false} />
                                        <Field name="chassi" type="text" component={renderField}
                                            max={17} label="Chassi:" css="form-control" readOnly={false} />
                                        <Field name="anoFabricacao" type="text" component={renderFieldNumber}
                                            formatacao="####" validate={[ano]}
                                            label="Ano Fabricação:" css="form-control" readOnly={false} />
                                        <Field name="quilometragem" component={renderFieldNumber}
                                            formatacao="#######"
                                            label="Quilometragem:" css="form-control" readOnly={false} />
                                    </div>
                                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
                                        <Field name="numeroEixo" type="text" component={renderFieldNumber}
                                            formatacao="##" label="N° de Eixos:" css="form-control" readOnly={false} />
                                        <Field name="dataVencimentoCsv" type="text" component={renderFieldDataNascimento}
                                            validate={[ehDataValida]}
                                            label="Data Vencimento CSV:" css="form-control" readOnly={false} />
                                    </div>
                                </SectionCard>

                                <SectionCard icon="shield" title="Seguro do Veículo" subtitle="Apólice, seguradora e tara">
                                    <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 1fr', gap: 16 }}>
                                        <Field name='empresaSeguro'
                                            options={Object.entries(empresaSeguro).map(([chave, elemento]) => ({
                                                descricao: `${elemento.cnpj} ${elemento.empresa}`,
                                                nome: chave,
                                            }))}
                                            component={renderFieldSelect}
                                            label='Empresa de Seguro:'
                                            placeholder='Selecione...'
                                            menuPortalTarget={document.body}
                                        />
                                        <Field name="apolice" type="text" component={renderField}
                                            label="Apólice:" css="form-control" readOnly={false} />
                                        <Field name="tara" type="text" component={renderField}
                                            label="Tara:" css="form-control" readOnly={false} />
                                    </div>
                                </SectionCard>

                                <SectionCard icon="category" title="Tipos de Serviço" subtitle="Categorias de serviço disponíveis neste veículo">
                                    <CheckboxGroupTipoServico
                                        tipoServico={this.props.veiculoSelecionado.tipoServico}
                                        handleValues={this.handleCheckboxGroup.bind(this)}
                                    />
                                </SectionCard>
                            </>
                        )}

                        {/* ── Save bar ── */}
                        <div className="vx-config-save-bar">
                            <span className="vx-config-save-hint">
                                <i className="material-icons">info_outline</i>
                                {!this.props.mapaSelecionadoVeiculo ? 'Selecione um modelo de assentos para salvar' : 'Todos os campos obrigatórios preenchidos'}
                            </span>
                            <button type="button"
                                disabled={!this.props.descricao || !this.props.mapaSelecionadoVeiculo || invalid}
                                onClick={() => this.salvar()}
                                className="btn btn-laranja vx-config-save-btn">
                                <i className="material-icons">save</i>
                                {ehEdicao ? 'Salvar Alterações' : 'Cadastrar Veículo'}
                            </button>
                        </div>

                    </div>
                </div>

                <ModalSelecionarMapaVeiculo veiculo={this.props.veiculoSelecionado} />
            </Autorizacao>
        );
    }
}

export const mapStateToProps = state => ({
    descricao: formValueSelector('formularioPainelCadastroVeiculo')(state, 'descricao'),
    mapaVeiculo: formValueSelector('formularioPainelCadastroVeiculo')(state, 'mapaVeiculo'),
    idVeiculo: formValueSelector('formularioPainelCadastroVeiculo')(state, 'idVeiculo'),
    idRastreamento: formValueSelector('formularioPainelCadastroVeiculo')(state, 'idRastreamento'),
    base64Veiculo: formValueSelector('formularioPainelCadastroVeiculo')(state, 'base64Veiculo'),
    urlImagem: formValueSelector('formularioPainelCadastroVeiculo')(state, 'urlImagem'),
    placa: formValueSelector('formularioPainelCadastroVeiculo')(state, 'placa'),
    modelo: formValueSelector('formularioPainelCadastroVeiculo')(state, 'modelo'),
    tipoVeiculo: formValueSelector('formularioPainelCadastroVeiculo')(state, 'tipoVeiculo'),
    quilometragem: formValueSelector('formularioPainelCadastroVeiculo')(state, 'quilometragem'),
    renavam: formValueSelector('formularioPainelCadastroVeiculo')(state, 'renavam'),
    chassi: formValueSelector('formularioPainelCadastroVeiculo')(state, 'chassi'),
    anoFabricacao: formValueSelector('formularioPainelCadastroVeiculo')(state, 'anoFabricacao'),
    numeroEixo: formValueSelector('formularioPainelCadastroVeiculo')(state, 'numeroEixo'),
    dataVencimentoCsv: formValueSelector('formularioPainelCadastroVeiculo')(state, 'dataVencimentoCsv'),
    empresaSeguro: formValueSelector('formularioPainelCadastroVeiculo')(state, 'empresaSeguro'),
    apolice: formValueSelector('formularioPainelCadastroVeiculo')(state, 'apolice'),
    tara: formValueSelector('formularioPainelCadastroVeiculo')(state, 'tara'),
    empresaSelecionada: state.empresaSelecionada,
    mapaSelecionadoVeiculo: state.mapaSelecionadoVeiculo,
    veiculoSelecionado: state.veiculoSelecionado,
});

export const mapDispatchToProps = dispatch => (
    bindActionCreators({
        changeFieldValue,
        cadastrarVeiculo,
        alterarVeiculo,
        alterarMapaSelecionadoVeiculo,
        buscarVeiculos,
    }, dispatch)
);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(reduxForm({
    form: 'formularioPainelCadastroVeiculo',
    validate,
})(PainelCadastrarVeiculo)));
